import { __decorate, __metadata } from "tslib";
import { IsUndefinable, PromotionAmountTypeEnum, PromotionDiscountBehaviourEnum, PromotionDiscountLevelEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDefined, IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsPositive, ValidateNested } from 'class-validator';
import { PromotionExposeGroup } from '../interface';
import { ReadPromotionTargetDto } from './ReadPromotionTargetDto';
export class ReadPromotionDiscountDto {
}
__decorate([
    ApiProperty({
        enum: PromotionAmountTypeEnum,
        description: 'type of promotion/discount, constant string, always set to "percent" ',
        example: PromotionAmountTypeEnum.PERCENT,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsEnum(PromotionAmountTypeEnum, { always: true }),
    __metadata("design:type", String)
], ReadPromotionDiscountDto.prototype, "amountType", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: "value of promotion/discount, when amount_type is percents - it's a fraction of 1", example: 0.15 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsNumber({}, { always: true }),
    IsPositive({ always: true }),
    __metadata("design:type", Number)
], ReadPromotionDiscountDto.prototype, "amount", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'max value of promotion/discount, always in fixed amount', example: 15 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: false }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadPromotionDiscountDto.prototype, "maxAmount", void 0);
__decorate([
    ApiProperty({
        enum: PromotionDiscountLevelEnum,
        description: 'define if that discount is item or check based',
        example: PromotionDiscountLevelEnum.CHECK_BASED,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [PromotionExposeGroup.PUT] }),
    IsDefined({ groups: [PromotionExposeGroup.CREATE] }),
    IsEnum(PromotionDiscountLevelEnum, { always: true }),
    __metadata("design:type", String)
], ReadPromotionDiscountDto.prototype, "level", void 0);
__decorate([
    ApiProperty({ enum: PromotionDiscountBehaviourEnum, description: 'define discount behaviour', example: PromotionDiscountBehaviourEnum.ADD_ITEM }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [PromotionExposeGroup.PUT] }),
    IsDefined({ groups: [PromotionExposeGroup.CREATE] }),
    IsEnum(PromotionDiscountBehaviourEnum, { always: true }),
    __metadata("design:type", String)
], ReadPromotionDiscountDto.prototype, "behaviour", void 0);
__decorate([
    ApiProperty({ isArray: true, type: () => ReadPromotionTargetDto, description: 'list of discount targets' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Type(() => ReadPromotionTargetDto),
    IsArray({ always: true }),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], ReadPromotionDiscountDto.prototype, "targets", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Number,
        description: 'If set, there must be at least this many items from promotion targets in a cart for the discount to apply.',
        minimum: 1,
        example: 5,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsPositive({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], ReadPromotionDiscountDto.prototype, "quantityMin", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Number,
        description: 'If set, there must be exactly this many items from promotion targets in the cart for the discount to apply.',
        minimum: 1,
        example: 5,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsPositive({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], ReadPromotionDiscountDto.prototype, "quantityExact", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Number,
        description: 'If set, the discount will be applied to a maximum of this many items from promotion targets.',
        minimum: 1,
        example: 5,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsPositive({ always: true }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], ReadPromotionDiscountDto.prototype, "quantityMax", void 0);
//# sourceMappingURL=ReadPromotionDiscountDto.js.map